import { Component, OnInit} from '@angular/core';
import { Location} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { ProvidersService } from '../../../services/providers.service';
import { UsersService } from '../../../services/users.service';
import {ModalConfirmComponent} from '../../../modal-confirm/modal-confirm.component';
import {ModalDetailComponent} from '../../../modal-detail/modal-detail.component';
import {UserComponent} from '../../users/user/user.component';

@Component({
  selector: 'app-provider-detail',
  templateUrl: './provider-detail.component.html',
  styleUrls: ['./provider-detail.component.scss']
})
export class ProviderDetailComponent implements OnInit {
  userId: any;
  userToken: any;
  editId: any;
  load = false;
  infoEdit: any = {};
  newContact: any = {};
  newBank: any = {};
  newUser: any = {};
  listProfiles: any;
  contactsList = [];
  banksList = [];
  usersList = [];
  typeFileUpload = '';
  loadBtn = false;
  editing = {};

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private provService: ProvidersService, public location: Location, private router: Router, private route: ActivatedRoute, private usersService: UsersService) {
    this.route.params.subscribe(params => {
      this.editId = params['id'];
    });

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    this.getProvider(this.editId);
    this.getProfiles();
  }

  ngOnInit() {
  }

  getProvider(id){
    this.load = true;
    this.provService.getProvider(id, this.userToken).then((data) => {
      this.infoEdit = data['msg'].info;
      this.contactsList = data['msg'].contacts;
      this.banksList = data['msg'].banks;
      this.usersList = data['msg'].users;
      this.load = false;
    }, (err) => {
      console.log(err);
      this.load = false;
      this.toastr.error(err['error'].msg, 'Error al cargar proveedor');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  getProfiles(){
    this.gralService.getProfiles(this.userToken).then((data) => {
      this.listProfiles = data['msg'];
    }, (err) => {
      console.log(err);
      this.listProfiles = null;
      this.toastr.error(err['error'].msg, 'Error al crear usuario');
    });
  }

  getcp(ev){
    if(ev.target.value.length == 5){
      console.log('sdfsfd');
      this.gralService.getPostalCode(ev.target.value).then((data) => {
        this.infoEdit.state = data['estado'];
        this.infoEdit.city = data['municipio'];
      }, (err) => {
        console.warn(err);
      });
    }
  }

  getRandomPass(){
    this.gralService.getRandom(8).then((data) => {
      this.newUser.password = data['msg'];
    }, (err) => {
      this.toastr.error(err['error'].msg, 'Error al generar contraseña');
    });
  }

  validFile(evt, type){
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    const pattern = /image-*/;
    const patternPdf = /pdf/;
    const reader = new FileReader();

    if (!file.type.match(pattern)) {
      if (!file.type.match(patternPdf)) {
        this.toastr.error('Formato de archivo inválido, solo se acepta imagen o pdf', 'Error al crear proveedor');
        return false;
      }else{
        this.typeFileUpload = 'application/pdf';
      }
    }else{
      this.typeFileUpload = file.type;
    }

    if(type == 1){
      this.infoEdit.cedula = evt.srcElement.files[0].name;
      reader.onload = this.loadedCedula.bind(this);
      reader.readAsBinaryString(file);
    }

    if(type == 2){
      this.infoEdit.acta = evt.srcElement.files[0].name;
      reader.onload = this.loadedActa.bind(this);
      reader.readAsBinaryString(file);
    }

    if(type == 3){
      this.newBank.bank_file = evt.srcElement.files[0].name;
      reader.onload = this.loadedBank.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  loadedCedula(readerEvt) {
    const binaryString = readerEvt.target.result;
    const base64textString = btoa(binaryString);
    this.infoEdit.cedula_base64 = 'data:'+this.typeFileUpload+';base64,'+base64textString;
  }

  loadedActa(readerEvt) {
    const binaryString = readerEvt.target.result;
    const base64textString = btoa(binaryString);
    this.infoEdit.acta_base64 = 'data:'+this.typeFileUpload+';base64,'+base64textString;
  }

  loadedBank(readerEvt) {
    const binaryString = readerEvt.target.result;
    const base64textString = btoa(binaryString);
    this.newBank.bank_file_base64 = 'data:'+this.typeFileUpload+';base64,'+base64textString;
  }

  updateInfo(){
    if(!this.validation()){
      return false;
    }

    this.loadBtn = true;

    this.provService.updateProvider(this.editId, this.infoEdit, this.userToken).then((data) => {
      this.loadBtn = false;
      this.toastr.success('Proveedor modificado correctamente', 'Editar proveedor');
    }, (err) => {
      this.loadBtn = false;
      console.log(err);
      this.toastr.error(err['error'].msg, 'Editar proveedor');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  validation(){
    if(!this.infoEdit.razon_social || !this.infoEdit.rfc || !this.infoEdit.country){
      this.toastr.error('Favor de llenar todos los datos obligatorios', 'Error al editar proveedor');
      return false;
    }

    return true;
  }

  addContact(){
    if(!this.newContact.name || !this.newContact.phone || !this.newContact.mail){
      this.toastr.error('Favor de llenar todos los campos', 'Agregar contacto');
      return false;
    }
    this.loadBtn = true;
    this.provService.addContactProvider(this.editId, this.newContact, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      this.toastr.success('Contacto agregado correctamente', 'Agregar contacto');
      this.contactsList.push(this.newContact);
      this.newContact = {};
    }, (err) => {
      this.loadBtn = false;
      console.log(err);
      this.toastr.error(err['error'].msg, 'Agregar contacto');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  deleteContact(id, idx){
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'delete', id: id, button: 'Eliminar', title: 'Eliminar contacto', content: '¿Esta seguro de eliminar este contacto?', icon: 'warning' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.loadBtn = true;
        this.provService.deleteContactProvider(id, this.userId, this.userToken).then((data) => {
          this.loadBtn = false;
          this.contactsList.splice(idx, 1);
          this.toastr.success('Contacto eliminado correctamente', 'Eliminar contacto');
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          this.toastr.error(err['error'].msg, 'Eliminar contacto');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

  addBank(){
    if(!this.newBank.bank_name || !this.newBank.bank_acount || !this.newBank.bank_clabe){
      this.toastr.error('Favor de llenar por lo menos un campo', 'Agregar banco');
      return false;
    }
    // console.log(this.newBank);
    this.loadBtn = true;
    this.provService.addBankProvider(this.editId, this.newBank, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      this.toastr.success('Dato bancario agregado correctamente', 'Agregar banco');
      this.banksList.push(data['msg']);
      this.newBank = {};
    }, (err) => {
      this.loadBtn = false;
      console.log(err);
      this.toastr.error(err['error'].msg, 'Agregar banco');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  deleteBank(id, idx){
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'delete', id: id, button: 'Eliminar', title: 'Eliminar dato bancario', content: '¿Esta seguro de eliminar este  dato bancario?', icon: 'warning' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.loadBtn = true;
        this.provService.deleteBankProvider(id, this.userId, this.userToken).then((data) => {
          this.loadBtn = false;
          this.banksList.splice(idx, 1);
          this.toastr.success('Dato bancario eliminado correctamente', 'Eliminar banco');
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          this.toastr.error(err['error'].msg, 'Eliminar banco');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

  addUser(){
    if(!this.newUser.name || !this.newUser.lastName || !this.newUser.email || !this.newUser.username || !this.newUser.password){
      this.toastr.error('Favor de llenar los campos obligatorios', 'Agregar usuario');
      return false;
    }
    this.loadBtn = true;
    this.provService.addUserProvider(this.editId, this.newUser, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      this.toastr.success('Usuario agregado correctamente', 'Agregar usuario');
      this.newUser.status = 'active';
      this.usersList.push(this.newUser);
      this.newUser = {};
    }, (err) => {
      this.loadBtn = false;
      console.log(err);
      this.toastr.error(err['error'].msg, 'Agregar usuario');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  changeStatusUser(id, status, idx){
    let dataa = {};
    if(status == 'inactive'){
      dataa = { type: 'delete', id: id, button: 'Desactivar', title: 'Desactivar usuario', content: '¿Esta seguro de deactivar este usuario?', icon: 'warning' };
    }else{
      dataa = { type: 'active', id: id, button: 'Activar', title: 'Activar usuario', content: '¿Esta seguro de activar este usuario?', icon: 'warning' };
    }


    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: dataa
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        const params = {status: status};
        this.usersService.statusUser(id, params, this.userId, this.userToken).then(data => {
          this.usersList[idx].status = status;
          this.toastr.success('Se cambio el estatus del usuario correctamente', 'Cambiar estatus');
        }, (err) => {
          console.log(err);
          this.toastr.error(err['msg'], 'Cambiar estatus');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

  viewFile(url){
    console.log(url);
    let type = 'view_jpg';
    const last = url.split('.').pop();
    if(last == 'pdf'){
      type = 'view_pdf';
    }

    this.dialog.open(ModalDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: {type: type, url: url, title: 'Documento'}
    });
  }

  updateContact(event, input, idx) {
    let editParams;
    if(input == 'name'){
      if(this.contactsList[idx].name == event.target.value){
        this.contactsList = [...this.contactsList];
        this.editing[idx + '-' + input] = false;
        return;
      }
      editParams = {name: event.target.value};
    }

    if(input == 'phone'){
      if(this.contactsList[idx].phone == event.target.value){
        this.contactsList = [...this.contactsList];
        this.editing[idx + '-' + input] = false;
        return;
      }
      editParams = {phone: event.target.value};
    }

    if(input == 'mail'){
      if(this.contactsList[idx].mail == event.target.value){
        this.contactsList = [...this.contactsList];
        this.editing[idx + '-' + input] = false;
        return;
      }
      editParams = {mail: event.target.value};
    }

    this.provService.editContactProvider(this.contactsList[idx].id, editParams, this.userId, this.userToken).then(data => {
      this.toastr.success('Se modifico el contacto correctamente', 'Editar contacto');
      this.editing[idx + '-' + input] = false;
      this.contactsList[idx][input] = event.target.value;
      this.contactsList = [...this.contactsList];
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'].msg, 'Editar contacto');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  updateBank(event, input, idx) {
    let editParams;
    if(input == 'name'){
      if(this.banksList[idx].name == event.target.value){
        this.banksList = [...this.banksList];
        this.editing[idx + '-' + input] = false;
        return;
      }
      editParams = {name: event.target.value};
    }

    if(input == 'acount'){
      if(this.banksList[idx].acount == event.target.value){
        this.banksList = [...this.banksList];
        this.editing[idx + '-' + input] = false;
        return;
      }
      editParams = {acount: event.target.value};
    }

    if(input == 'clabe'){
      if(this.banksList[idx].clabe == event.target.value){
        this.banksList = [...this.banksList];
        this.editing[idx + '-' + input] = false;
        return;
      }
      editParams = {clabe: event.target.value};
    }

    this.provService.editBankProvider(this.banksList[idx].id, editParams, this.userId, this.userToken).then(data => {
      this.toastr.success('Se modifico el dato bancario correctamente', 'Editar dato bancario');
      this.editing[idx + '-' + input] = false;
      this.banksList[idx][input] = event.target.value;
      this.banksList = [...this.banksList];
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'].msg, 'Editar dato bancario');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  updateValue(event, cell, rowIndex) {
    console.log('inline editing rowIndex', rowIndex);
    this.editing[rowIndex + '-' + cell] = false;
    this.contactsList[rowIndex][cell] = event.target.value;
    this.contactsList = [...this.contactsList];
    console.log('UPDATED!', this.contactsList[rowIndex][cell]);
  }



  editUser(id, idx){
    this.usersService.getUser(id, this.userToken).then((data) => {
      const dialogRef = this.dialog.open(UserComponent, {
        minWidth: '50%',
        position: {
          top: '6%'
        },
        data: { type: 'edit', id: id, info: data['msg'], userId: this.userId, userToken: this.userToken, profiles: this.listProfiles }
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.usersList[idx] = result['data'];
        }
      });
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'].msg, 'Error en modulo usuarios');
    });
  }

}
